import type { ResponseApiInterface } from '@/interfaces/base/responseApi.interface';
import type { ResultOrError } from '@/interfaces/base/resultOrError';
import { useNotificationStore } from '@/stores/notification.store';

/**
 * Função utilitária para tratar as respostas do serviço
 * @param response Resposta do serviço
 * @returns ResultOrError com os dados ou erro
 */
export function useHandleServiceResponse<T>(
  response: ResponseApiInterface<T>,
): ResultOrError<T> {
  if ('notification' in response) {
    const notificationStore = useNotificationStore();
    notificationStore.addNotification(response.notification!);
    return [null, new Error(response.notification.message)];
  }
  return [response.data, null];
}
